import * as React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { alertActions } from "../redux/actions/alert.actions";
import { SnackbarOrigin } from "@mui/material/Snackbar";
import { storeStateType } from "../redux/store";
import { toast } from "react-toastify";

export interface State extends SnackbarOrigin {
  open: boolean;
}

const SnackBar = () => {
  const dispatch = useDispatch();

  const flashMessge = useSelector((state: storeStateType) => state.alert);
  const [themeMode, setThemeMode] = React.useState<"dark" | "light">("light");

  useEffect(() => {
    const themeMode = localStorage.getItem("themeMode");
    if (themeMode === "dark") {
      setThemeMode("dark");
    } else {
      setThemeMode("light");
    }
  }, []);

  useEffect(() => {
    const triggerFadeOut = () => {
      dispatch(alertActions.clear());
    };
    if (flashMessge.message) {
      switch (flashMessge.type) {
        case "success":
          toast.success(flashMessge.message, {
            theme: themeMode === "dark" ? "dark" : "light",
            hideProgressBar: true,
          });
          break;
        case "error":
          toast.error(flashMessge.message, {
            theme: themeMode === "dark" ? "dark" : "light",
            hideProgressBar: true,
          });
          break;
        case "warning":
          toast.warning(flashMessge.message, {
            theme: themeMode === "dark" ? "dark" : "light",
            hideProgressBar: true,
          });
          break;
      }
      setTimeout(triggerFadeOut, 3000);
    }

    if (flashMessge?.messages?.length >= 0) {
      setTimeout(() => {}, 3000);
    }
  }, [flashMessge, dispatch, themeMode]);

  return <></>;
};

export default SnackBar;
